import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BroadcastReceiver = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Create broadcast channel to listen for logout messages
    const broadcastChannel = new BroadcastChannel('my-logout-channel');

    const handleMessage = (event) => {
      if (event.data.type === 'logout') {
        // Redirect to logout URL when logout message is received
        navigate('/logout');
      }
    };

    // Listen for messages
    broadcastChannel.addEventListener('message', handleMessage);

    // Cleanup function
    return () => {
      broadcastChannel.removeEventListener('message', handleMessage);
      broadcastChannel.close();
    };
  }, [navigate]);

  // This component doesn't render anything
  return null;
};

export default BroadcastReceiver;
